module.exports = {"news":{"id":2,"date":"10 ноября 2017","title":"Вырос объем инвестиций в&nbsp;вексельную программу Автобана","text":"Увеличен объем финансирования дорожно-строительной компании &laquo;Автобан&raquo;. Рост инвестиций составил 50&nbsp;миллионов рублей."},"chart":"/main/chart.png"}


//////////////////
// WEBPACK FOOTER
// ./src/content/main.json
// module id = 491
// module chunks = 0